import React, {useEffect, useState} from "react";
import {Modal, Button} from "react-bootstrap";
import AlertBox from "../alert-box/alertBox";
import "./disclaimer-modal.css";

const DisclaimerModal = ({
    storageKey,
    title,
    description,
    variant = "warning",
}) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const isConfirmed = localStorage.getItem(storageKey);
        if (!isConfirmed) {
            setShow(true);
        }
    }, [storageKey]);

    const handleConfirm = () => {
        localStorage.setItem(storageKey, "true");
        setShow(false);
    };

    return (
        <Modal show={show} onHide={handleConfirm} centered backdrop="static">
            <Modal.Body>
                <AlertBox title={title} description={description} variant={variant} closable={false}/>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button
                    variant="primary"
                    className="disclaimer-modal-button"
                    onClick={handleConfirm}
                >
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DisclaimerModal;
